import React from 'react';
import styled, { keyframes } from 'styled-components';
import { CheckCircle, X } from 'lucide-react';

interface ChallengeSentModalProps {
  isOpen: boolean;
  onClose: () => void;
  accepterName: string;
}

const slideUp = keyframes`
  from { opacity: 0; transform: translateY(50px); }
  to { opacity: 1; transform: translateY(0); }
`;

const checkAnimation = keyframes`
  0% { transform: scale(0); }
  50% { transform: scale(1.2); }
  100% { transform: scale(1); }
`;

const Overlay = styled.div<{ $isOpen: boolean }>`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.6);
  display: ${props => props.$isOpen ? 'flex' : 'none'};
  align-items: center;
  justify-content: center;
  z-index: 2000;
`;

const Modal = styled.div`
  background: white;
  border-radius: 20px;
  padding: 32px;
  max-width: 400px;
  width: 90%;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
  animation: ${slideUp} 0.4s ease-out;
  text-align: center;
`;

const IconContainer = styled.div`
  width: 80px;
  height: 80px;
  margin: 0 auto 20px;
  background: linear-gradient(135deg, #28a745 0%, #20c997 100%);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  animation: ${checkAnimation} 0.5s ease-out;
  box-shadow: 0 8px 25px rgba(40, 167, 69, 0.4);
`;

const Title = styled.h2`
  margin: 0 0 12px;
  font-size: 24px;
  font-weight: 700;
  color: #28a745;
`;

const Message = styled.p`
  margin: 0 0 24px;
  font-size: 16px;
  color: #666;
  line-height: 1.6;
`;

const AccepterName = styled.span`
  font-weight: 700;
  color: #333;
`;

const OkButton = styled.button`
  width: 100%;
  padding: 14px;
  background: linear-gradient(90deg, #28a745 0%, #20c997 100%);
  color: white;
  border: none;
  border-radius: 12px;
  font-size: 16px;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.3s;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(40, 167, 69, 0.4);
  }

  &:active {
    transform: translateY(0);
  }
`;

const ChallengeSentModal: React.FC<ChallengeSentModalProps> = ({
  isOpen,
  onClose,
  accepterName,
}) => {
  if (!isOpen) return null;

  return (
    <Overlay $isOpen={isOpen} onClick={onClose}>
      <Modal onClick={e => e.stopPropagation()}>
        <IconContainer>
          <CheckCircle size={40} color="white" />
        </IconContainer>
        
        <Title>🎮 Gửi Thách Đấu Thành Công!</Title>
        
        <Message>
          Lời mời thách đấu đã được gửi tới <AccepterName>{accepterName}</AccepterName>. 
          Đợi đối thủ chấp nhận và hoàn thành game để so kết quả nhé!
        </Message>
        
        <OkButton onClick={onClose}>
          OK
        </OkButton>
      </Modal>
    </Overlay>
  );
};

export default ChallengeSentModal;
